import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import { PageHeader } from "./ServicesPage";
import { MEDIA } from "@/constants/business";
import { PRODUCTS } from "@/constants/products";

export default function ProductsPage() {
  return (
    <>
      <SEO
        title="Elevators & Escalators Product Range | Passenger, Home Lift, Freight, Escalator | Vila"
        description="Explore Vila's product range: passenger elevators, home lifts, freight elevators, hospital lifts, escalators and moving walkways — manufactured in Bangalore."
        path="/products"
        keywords="passenger elevator, home lift, freight elevator, hospital lift, escalator manufacturer, moving walkway bangalore"
      />

      <PageHeader
        eyebrow="Product Range"
        title="Elevators & escalators engineered for every scale."
        desc="From compact home lifts to high-flow airport escalators — our range covers every vertical transportation need."
        image={MEDIA.productEscalator}
      />

      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          {PRODUCTS.map((p) => {
            const Icon = Icons[p.icon] || Icons.Package;
            return (
              <motion.div
                key={p.slug}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7 }}
                data-testid={`product-card-${p.slug}`}
                className="group border border-[#e5ddd0] bg-[#faf7f2]/40 overflow-hidden hover:border-[#b08d57]/50 transition-colors flex flex-col"
              >
                <Link to={`/products/${p.slug}`} className="relative aspect-[16/9] overflow-hidden block">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute top-4 left-4 bg-[#b08d57] text-white text-[10px] uppercase font-bold tracking-widest px-3 py-1">{p.tag}</div>
                </Link>
                <div className="p-8 flex-1 flex flex-col">
                  <div className="w-12 h-12 border border-[#b08d57]/40 text-[#b08d57] flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className="font-display text-2xl font-bold text-[#1a1a1a] mb-3">{p.title}</h3>
                  <p className="text-[#6b6b6b] leading-relaxed mb-6 flex-1">{p.short}</p>
                  <ul className="space-y-2 mb-6">
                    {p.features.slice(0, 3).map((f) => (
                      <li key={f} className="text-sm text-[#8a8a8a] flex items-center gap-2">
                        <span className="w-1 h-1 bg-[#b08d57]" /> {f}
                      </li>
                    ))}
                  </ul>
                  <Link
                    to={`/products/${p.slug}`}
                    data-testid={`product-view-details-${p.slug}`}
                    className="inline-flex items-center gap-2 text-[#b08d57] hover:text-[#b08d57] font-semibold uppercase text-xs tracking-wider"
                  >
                    View Details & Specs <ArrowRight className="w-3 h-3" />
                  </Link>
                </div>
              </motion.div>
            );
          })}
        </div>
      </section>
    </>
  );
}
